function filterReviewWithKeywords({ reviewText }) {
  return /advisor|advice|advis/.test(reviewText);
}

export default filterReviewWithKeywords;
